<template>
<div>
  <p v-if="stats.total==stats.success">
    Wysłano poprawnie do wszystkich: <strong>{{ stats.total }}</strong> subskrybentów!
  </p>
  <p v-if="stats.total!=stats.success">
      Próbowano wysłać do <strong>{{ stats.total}}</strong>. Wysłano z powodzeniem: <strong>{{ stats.success }}</strong>.Nie można było wysłać do <strong>{{ stats.failure }}</strong>.
  </p>
    <table class="table">
        <tr>
            <th>
                E-mail
            </th>
            <th>
                Wysłano
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'send_on'" :direction="meta.direction"></sorting>
            </th>
            <th>
                Status
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'send_status'" :direction="meta.direction"></sorting>
            </th>

        </tr>
        <tr v-for="item in items">
            <td>
                {{ item.email.email }}
            </td>
            <td>
                {{ item.send_on_formated }}
            </td>
            <td>
                <span class="badge badge-gray" v-if="item.send_status==1">Wysłano</span>
                <span class="badge badge-alert" v-if="item.send_status!=1">Nie można było wysłać</span>
            </td>

        </tr>
    </table>
    <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>

</template>
<script>
import Messages from './../../services/Messages'
import EventEmitter from './../../services/EventEmitter'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  props: ['id'],
  data () {
    return {
      stats: {
        total: 0,
        failure: 0,
        success: 0
      }
    }
  },
  methods: {
    paginate (meta) {
      this.setLoading(true)
      Messages.paginateSendLog(this.id, meta).then(this.success)
    },
    success (res) {
      this.items = res.data.items
      this.stats = res.data.stats
      const filter = this.meta.filter
      this.meta = res.data.meta
      this.meta.filter = filter
      this.setLoading(false)
    }
  },
  mounted () {
    EventEmitter.$on('messages.send-log.reload', () => {
      this.meta.current_page = 1
      this.reload()
    })
  }
  // events: {
  //   'messages.send-log.reload': function () {
  //     this.reload()
  //   }
  // }
}
</script>


// WEBPACK FOOTER //
// SendLog.vue?05097eb0